const robot = [{
  desc: '群聊天信息定位',
  options: {
    url: '/order/quote/queryOrderChatMsg',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询群订单',
  options: {
    url: '/price/apply/queryOrderApply',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询群聊天记录',
  options: {
    url: '/chat/chatdata/queryChatHistory',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '新增修改机器人',
  options: {
    url: '/weixin/robot/addOrUpdateWeiXinRobot',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询机器人 ',
  options: {
    url: '/weixin/robot/queryWeiXinRobot',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询群聊列表信息 ',
  options: {
    url: '/weixin/room/queryWeiXinRoom',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '更新群聊信息 ',
  options: {
    url: '/weixin/room/saveWeiXinRoom',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '获取业务员/出单员信息',
  options: {
    url: '/customer/querySmallCustomer',
    method: 'post',
    baseURL: '/insapi/v3/insured/base'
  }
}, {
  desc: '接单机器人统计',
  options: {
    url: '/report/priceApplyReport',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: '报价机器人统计',
  options: {
    url: '/report/applyPriceReport',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: '回复机器人统计',
  options: {
    url: '/report/responderReport',
    method: 'post',
    baseURL: '/insapi/v3/insured/price'
  }
}, {
  desc: '回复机器人长期在线',
  options: {
    url: '/securityConfig/saveOrUpdateRobotId',
    method: 'post',
    baseURL: '/insapi/v3'
  }
}, {
  desc: '查询回复机器人设置',
  options: {
    url: '/robot/weixin/robot/queryWeiXinRobot',
    method: 'post',
    baseURL: '/insapi/v3'
  }
}, {
  desc: '回复机器人设置',
  options: {
    url: '/robot/weixin/robot/addOrUpdateWeiXinRobot',
    method: 'post',
    baseURL: '/insapi/v3'
  }
}, {
  desc: '查询所有可选保司',
  options: {
    url: '/robotPolicy/queryRobotSuppliers',
    method: 'get',
    baseURL: '/insapi/v3'
  }
}, {
  desc: '查询发送报价单配置',
  options: {
    url: '/price/order/queryInsPriceItemShareConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '保存发送报价单配置',
  options: {
    url: '/price/order/saveInsPriceItemShareConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '设置群关联人员信息',
  options: {
    url: '/weixin/room/saveRoomRelateCustomer',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询应用的id',
  options: {
    url: '/weixin/app/queryWeixinRobotAppCorpId',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询企业微信的人员',
  options: {
    url: '/weixin/wxuser/queryLiteUser',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询已经同步的群主',
  options: {
    url: '/weixin/room/querySyncConfig',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '同步群主',
  options: {
    url: '/weixin/room/syncWeiXinRoomByConfig',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '账号激活接口',
  options: {
    url: '/weixin/license/activeAccount',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '转移许可接口',
  options: {
    url: '/weixin/license/activeTransfer',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询许可证激活数量',
  options: {
    url: '/weixin/license/queryLicenseActiveNum',
    method: 'post',
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询同步任务状态',
  options: {
    url: '/weixin/room/querySyncTask',
    method: 'post',
    showLoading: false,
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询接单日志',
  options: {
    url: '/order/order/queryOrderApplyFlow',
    method: 'post',
    showLoading: false,
    baseURL: '/insapi/v3/robot'
  }
}, {
  desc: '查询群绑定日志',
  options: {
    url: '/weixin/room/queryWeiXinRoomBind',
    method: 'post',
    showLoading: false,
    baseURL: '/insapi/v3/robot'
  }
}]
export default robot



// WEBPACK FOOTER //
// ./src/api/robot.js